import { Component, HostBinding, OnInit } from '@angular/core';
import { UtilityService, ErrorService, TranslateService } from '@mono-repo/util';
import { ConfigService } from '../../config.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  @HostBinding('class') class = 'dt-error dt-c-interactive-dialog';

  public error: any;
  public errorMessage: string;
  public contactPhone: string = this.configService.getConfig().contactPhone;
  public contactEmail: string = this.configService.getConfig().contactEmail;
  public route: string =
    this.utilityService.getSourceUrl4Ever() || `/${this.configService.getConfig()?.initialRoute || ''}`;

  constructor(
    private readonly errorService: ErrorService,
    private readonly utilityService: UtilityService,
    private readonly configService: ConfigService,
    private readonly translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.translateService.setCurrentModuleTranslation('error');
    this.error = this.errorService.getError();
    this.errorMessage = this.errorService.getErrorMessage();
  }

  // public contactByPhone(): void {
  //   this.utilityService.openPhoneLink(this.configService.getConfig().contactPhoneIso);
  // }

  // public contactByEmail(): void {
  //   this.utilityService.openMailLink(this.configService.getConfig().contactEmail);
  // }
}
